import { useTranslation } from 'react-i18next';
import { translateText } from '../util/translateText';

function useTranslator() {
  const { i18n } = useTranslation();

  function translate(name: string | number | null | undefined) {
    return translateText(i18n, name);
  }

  return translate;
}

export default useTranslator;
